export default __webpack_public_path__ + "static/media/hht2_Intonation_19.e5b10f69.png";